var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import React, { useState } from 'react';
;
export var TableContext = React.createContext({
    setSelectAll: function () { },
    selectAll: false,
    selectedRowIds: [],
    setSelectedRowIds: function () { },
    handleSelectAll: function () { },
    handleRowSelect: function () { }
});
export var useTableContext = function (checkboxConfig) {
    var _a = useState(false), selectAll = _a[0], setSelectAll = _a[1];
    var _b = useState(checkboxConfig.enable ? checkboxConfig.selectedRowIds : []), selectedRowIds = _b[0], setSelectedRowIds = _b[1];
    var callOnSelectHandler = function (e, value) {
        if (checkboxConfig.enable && checkboxConfig.onSelect) {
            checkboxConfig.onSelect(e, value);
        }
    };
    /**
     * Selects / de-selects all checkboxes
     * @param {Event} - e
     * @param {string[]} - rowIds
     */
    var handleSelectAll = function (e, rowIds) {
        var campaignIds = !selectAll ? rowIds : [];
        setSelectedRowIds(campaignIds);
        setSelectAll(!selectAll);
        callOnSelectHandler(e, 'all');
    };
    /**
     * Handles individual row selection
     * @param {Event} - e
     * @param value - {string}
     */
    var handleRowSelect = function (e, value) {
        var rowIds = selectedRowIds.includes(value)
            ? selectedRowIds.filter(function (c) { return c !== value; })
            : __spreadArray(__spreadArray([], selectedRowIds), [value]);
        setSelectedRowIds(rowIds);
        callOnSelectHandler(e, value);
    };
    return {
        selectAll: selectAll,
        setSelectAll: setSelectAll,
        selectedRowIds: selectedRowIds,
        setSelectedRowIds: setSelectedRowIds,
        handleRowSelect: handleRowSelect,
        handleSelectAll: handleSelectAll
    };
};
